import { Group, Layout, TabItem as DSTabItem, Tabs, Text } from '@melio/penny';
import { Outlet } from 'react-router-dom';

export type TabsLayoutProps<T extends string = string> = {
  label: string;
  tabs: TabItem<T>[];
  activeTab: T;
  onChange: (name: T) => void;
};

export function TabsLayout<T extends string = string>({
  activeTab,
  label,
  onChange,
  tabs,
  ...props
}: TabsLayoutProps<T>) {
  return (
    <Layout variant="full" backgroundColor="white" data-component={TabsLayout.displayName} {...props}>
      <Group variant="vertical">
        <Group spacing="m">
          <Text textStyle="heading1Semi">{label}</Text>
        </Group>
        <Tabs tabs={tabs} activeTab={activeTab} onChange={onChange as never} />
        <Outlet />
      </Group>
    </Layout>
  );
}
TabsLayout.displayName = 'TabsLayout';

export type TabItem<T = string> = Override<DSTabItem, { name: T }>;
